<div class="custom-tooltip" [style.width]="width">
    <p>
        <span class="tooltiptext" [innerHTML]="this.getTooltip()"></span>
    </p>
</div>
